'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { noop } from 'lodash';
import { Avatar, Box, Button, Divider, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
export default function Dropdown({ icon, image, name, label, anchorOrigin = 'top-right', onClick = noop, items = [], sx = {}, tooltip = '', redirect = noop }) {
    const [anchor, setAnchor] = useState(null);
    const handleOpen = (event) => {
        setAnchor(event.currentTarget);
    };
    const handleClose = (config) => {
        setAnchor(null);
        if (config.url) {
            redirect(config.url);
        }
        else if (config.event) {
            onClick({ event: config.event });
        }
    };
    const [vertical, horizontal] = anchorOrigin.split('-');
    return (_jsxs(Box, { sx: { flexGrow: 0, ...sx.root }, children: [_jsx(Tooltip, { title: tooltip, sx: { ...sx.tooltip }, children: icon || image || name ? (_jsxs(IconButton, { onClick: handleOpen, sx: { p: 0, ...sx.trigger }, children: [icon && _jsx(Box, { component: icon, sx: sx.icon }), (image || name) && _jsx(Avatar, { alt: name, sx: sx.avatar, src: image })] })) : (_jsx(Button, { onClick: handleOpen, sx: { p: 0, ...sx.trigger }, children: label })) }), _jsx(Menu, { sx: sx.menu, anchorEl: anchor, anchorOrigin: {
                    vertical,
                    horizontal
                }, keepMounted: true, transformOrigin: {
                    vertical,
                    horizontal
                }, open: Boolean(anchor), onClose: handleClose, children: items.map(({ component, label = '', divider = false, ...rest }, idx) => {
                    if (divider) {
                        return _jsx(Divider, { sx: sx.divider }, `divider-${idx}`);
                    }
                    return (_jsxs(MenuItem, { onClick: () => handleClose(rest), sx: sx.menuItem, children: [component && _jsx(Box, { component: component, sx: sx.component }), label && (_jsx(Typography, { textAlign: "center", sx: sx.menuItemText, children: label }))] }, `${name}-option-${idx}`));
                }) })] }));
}
